import React from 'react';
import { TicketDetailsProvider } from '../context/TicketDetailsProvider';
import TicketDetails from './TicketDetails';

export default function TicketDetailsWrapper() {
  return (
    <TicketDetailsProvider>
      <TicketDetails />
    </TicketDetailsProvider>
  );
}
